import { z } from 'zod'

import { dbEntitySchema } from './system'

export const reviewSchema = dbEntitySchema.extend({
  syncedToVenga: z.boolean().optional(),
  user: z.string(),
  booking: z.string(),
  venue: z.string(),
  city: z.string(),
  //   questions: [QuestionSchema],
  comment: z.string().optional(),
  pending: z.boolean().optional(),
  pendingApproval: z.boolean().optional(),
  rating: z.number().optional(),
  //   images: [Image.schema],
})
